import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { useDispatch, useSelector } from "react-redux";
import { toggleTalentActiveThunk } from "../../store/reducers/plantels/plantels.thunks";
import { closeConfirmTalentToggle } from "../../store/reducers/plantels/talentsByPlantels.reducer";

const TalentByPlantelConfirmModal = () => {
  const dispatch = useDispatch();

  const { confirmToggleOpen, toggleTalentId, toggling } = useSelector(
    (state) => state.talentosByPlantels,
  );

  const handleConfirm = () => {
    dispatch(toggleTalentActiveThunk(toggleTalentId));
  };

  return (
    <Modal
      open={confirmToggleOpen}
      title="Confirmar cambio de estado"
      onClose={() => dispatch(closeConfirmTalentToggle())}
    >
      <p>¿Seguro que deseas cambiar el estado de este talento?</p>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          className="btn btn-secondary"
          onClick={() => dispatch(closeConfirmTalentToggle())}
          disabled={toggling}
        >
          Cancelar
        </button>

        <button
          className="btn btn-danger position-relative"
          onClick={handleConfirm}
          disabled={toggling}
          style={{ minWidth: 110 }}
        >
          <span style={{ visibility: toggling ? "hidden" : "visible" }}>
            Confirmar
          </span>

          {toggling && (
            <span className="position-absolute top-50 start-50 translate-middle">
              <Loader size="sm" />
            </span>
          )}
        </button>
      </div>
    </Modal>
  );
};

export default TalentByPlantelConfirmModal;
